import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Rating from 'react-rating';
import ChatContext from '../../context/index';
import '../../context/global';
import api from '../../context/api';

import './chatdetailrate.scss';

const ChatDetailRate = ({ ...props }) => {
  const [starSelected, setStarSelected] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [selectedMoreKey, setSelectedMoreKey] = useState(null);

  const { activeRoom, chatRateToggle, showRate } = props;

  const { userId, userToken, currentUser, trans } = useContext(ChatContext);

  const _fetchMetaData = () => {
    api
      .get(`chat/rate/${JSON.parse(activeRoom.data).chatroom_id}/`, {
        headers: {
          'x-sendbird-id': userId,
          'x-sendbird-token': userToken,
        },
      })
      .then(response => {
        let moreKey = null;
        if (response.data.rated_by_buyer) {
          moreKey = response.data.buyer_feedback;
        } else {
          moreKey = response.data.seller_feedback;
        }
        setStarSelected(response.data.stars);
        setSelectedMoreKey(moreKey);
        setIsReadOnly(true);
      })
      .catch(() => {
        setStarSelected(0);
        setSelectedMoreKey(null);
        setIsReadOnly(false);
      });
  };

  useEffect(() => {
    _fetchMetaData();
    setSubmitted(false);
  }, [activeRoom.url]);

  const _handleStarChange = starValue => {
    setStarSelected(starValue);
  };

  const _handleMoreFeedbackChange = e => {
    setSelectedMoreKey(e.target.dataset.key);
  };

  const _handleSubmit = () => {
    const userSplit = userId.split('-');
    const buyer = activeRoom.inviter.userId === currentUser.userId;
    let buyer_feedback = null;
    let seller_feedback = null;
    if (buyer) {
      buyer_feedback = selectedMoreKey;
    } else {
      seller_feedback = selectedMoreKey;
    }
    const postData = {
      user: parseInt(userSplit[1], 10),
      chat: JSON.parse(activeRoom.data).chatroom_id,
      stars: starSelected,
      buyer_feedback,
      seller_feedback,
    };
    api
      .post('chat/rate/', postData, {
        headers: {
          'x-sendbird-id': userId,
          'x-sendbird-token': userToken,
        },
      })
      .then(() => {
        setSubmitted(true);
        setIsReadOnly(true);
      });
  };

  const _handleClose = () => {
    chatRateToggle();
  };

  const showRateClass = showRate ? 'show' : 'hide';
  const emptySymbol = <i className="material-icons">star_border</i>;
  const fullSymbol = <i className="material-icons">star</i>;

  const buyer = activeRoom.inviter.userId === currentUser.userId;
  let moreFeedback = global.ratingMoreFeedback.seller;
  if (buyer) {
    moreFeedback = global.ratingMoreFeedback.buyer;
  }
  const moreFeedbacks = Object.keys(moreFeedback).map(key => {
    const selectedClass = key === selectedMoreKey ? 'selected' : '';
    return (
      <button
        className={`chat-detail-rate-box-more-feedback-item ${selectedClass}`}
        key={key}
        onClick={_handleMoreFeedbackChange}
        data-key={key}
        type="button"
      >
        {trans[moreFeedback[key]]}
      </button>
    );
  });

  const ratingReadOnly = isReadOnly;
  if (submitted) {
    return (
      <div className={`chat-detail-rate ${showRateClass}`}>
        <div className="chat-detail-rate-box">
          <button className="chat-detail-rate-box-close small" onClick={_handleClose} type="button">
            <i className="material-icons">close</i>
          </button>
          <div className="chat-detail-rate-box-more-text">{trans['Thanks for your feedback!']}</div>
        </div>
      </div>
    );
  }
  if (ratingReadOnly) {
    return (
      <div className={`chat-detail-rate ${showRateClass}`}>
        <div className="chat-detail-rate-box">
          <button className="chat-detail-rate-box-close" onClick={_handleClose} type="button">
            <i className="material-icons">close</i>
          </button>
          <div className="chat-detail-rate-box-title" style={{ marginTop: '20px' }}>
            {trans['You have rated this conversation.']}
            <br />
            {trans['Thanks for your feedback!']}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={`chat-detail-rate ${showRateClass}`}>
      <div className="chat-detail-rate-box">
        <button className="chat-detail-rate-box-close" onClick={_handleClose} type="button">
          <i className="material-icons">close</i>
        </button>
        <div className="chat-detail-rate-box-title">
          {trans['How was the quality of this chat?']}
          <br />
          {trans['Please note that you can only rate this conversation once.']}
        </div>
        <Rating
          emptySymbol={emptySymbol}
          fullSymbol={fullSymbol}
          initialRating={starSelected}
          onClick={_handleStarChange}
          readonly={ratingReadOnly}
        />
        <div className="chat-detail-rate-box-more-text">
          {trans['More feedback for this chat (optional)']}
        </div>
        <div className="chat-detail-rate-box-more-feedback">{moreFeedbacks}</div>
        {!ratingReadOnly ? (
          <button className="submit-rating button" onClick={_handleSubmit} type="button">
            {trans.Submit}
          </button>
        ) : null}
      </div>
    </div>
  );
};

ChatDetailRate.propTypes = {
  activeRoom: PropTypes.shape().isRequired,
  chatRateToggle: PropTypes.func.isRequired,
  showRate: PropTypes.bool.isRequired,
};

export default ChatDetailRate;
